'use strict';

/**
 * @classname GetChildCategories
 * @classdesc 表示タイプ変更
 */
export default class GetChildCategories {
	/**
	 * @constructor
	 * @param {jQuery} $e - .get-child-category
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		if($e.hasClass('cat1')){
			this._categoryLevel = 1;
		}else if($e.hasClass('cat2')){
			this._categoryLevel = 2;
		}
		console.log(this._categoryLevel);
		$e.on('change', () => this.onChange());
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof GetChildCategories
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange/ level: ${this._categoryLevel}`);
		const categoryId = this._$e.val();
		if(categoryId === ''){
			$('.input-select__select[name=cat3]').closest('.input-select').remove();
			if(this._categoryLevel === 1){
				$('.input-select__select[name=cat2]').closest('.input-select').remove();
			}
		}else{
			this._controller.getChildCategories(categoryId, this._categoryLevel);
		}
	};
};
